import React, { useEffect, useRef, useMemo } from 'react'
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Layout, Row, Col, Dropdown } from 'antd'
import { SettingOutlined, QuestionCircleOutlined, UserOutlined } from '@ant-design/icons'
import styles from '../../styles/components/layout/mainLayout.module.css'
import Consts from '../../configs/consts'

const { Content } = Layout
const SignUpLayout = ({ children, style, back, title, description, leftItem, rightItem, AuthStore, nomenu = false, hideTitle = false }) => {
  const contentRef = useRef(null)
  const router = useRouter()

  useEffect(() => {
    document.documentElement.classList.add('main-layout-background')
    document.body.classList.add('main-layout-background')

    return () => {
      document.documentElement.classList.remove('main-layout-background')
      document.body.classList.remove('main-layout-background')
    }
  }, [])

  const handleBack = () => {
    if (typeof back === 'string') {
      router.push(back)
    } else if (typeof back === 'function') {
      back()
    }
  }

  const contentProps = nomenu ? { xs: 24, sm: 20, md: 16, lg: 12 } : { span: 24 }

  const footer = <footer className={styles.footer}>©2026 ORSO Inc. All Rights Reserved.</footer>

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {title && (
        <Head>
          <title>{`${Consts.ServiceName} | ${title}`}</title>
        </Head>
      )}
      <header className={styles.simpleHeader} data-service-header>
        {back && (
          <a className={styles.simpleHeaderBack} onClick={handleBack} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleBack()}>
            <img src="/img/back_button.svg" alt="" className={styles.simpleHeaderBackIcon} aria-hidden="true" />
            戻る
          </a>
        )}
        <h1 className={styles.simpleHeaderTitle}>{title || ''}</h1>
      </header>
      <Content ref={contentRef} className={`${styles.contentArea} ${styles.contentAreaSimple}`}>
        <div
          style={{
            display: 'flex',
            minHeight: 'calc(100vh - 64px - 28px - 80px)',
            paddingTop: '40px',
            paddingBottom: '40px',
            width: '100%',
            alignItems: 'center',
          }}>
          {children}
        </div>
      </Content>
      {footer}
    </Layout>
  )
}

export default SignUpLayout
